import React from "react";
import { FilterFunIcon } from ".";

const CourseFilterIcon = ({ classNames }) => {
  return (
    <div className={`blogFilter ${classNames ? classNames : ""}`}>
      <FilterFunIcon className="p-[2px] md:p-0" />
    </div>
  );
};

export default CourseFilterIcon;
